import React from 'react'
import { css } from 'glamor'

import isArray from 'lodash/isArray'
import partial from 'lodash/partial'
import overSome from 'lodash/overSome'
import isString from 'lodash/isString'
import isNumber from 'lodash/isNumber'

import queryString from 'query-string'


const notProps = overSome([React.isValidElement, isArray, isString, isNumber])

export const $ = (element, ...rest) =>
  React.createElement(
    element,
    ...notProps(rest[0])
      ? [null, ...rest]
      : rest)

export const div = partial($, 'div')
export const a = partial($, 'a')
export const span = partial($, 'span')
export const p = partial($, 'p')
export const svg = partial($, 'svg')
export const path = partial($, 'path')
export const b = partial($, 'b')
export const img = partial($, 'img')


export const slideIn = css.keyframes({
  '0%': { transform: 'translateX(100%)' },
  '100%': { transform: 'translateX(0)' }
})

export const slideOut = css.keyframes({
  '0%': { transform: 'translateX(0)' },
  '100%': { transform: 'translateX(100%)' }
})

export function getImagePath() {
  const index = Math.round(Math.random() * 49) + 1
  return `/images/${index}.jpg`
}

export function getShortedString(str) {
  if (!str || str.length < 10) return str
  return `${str.substr(0, 4)}...${str.substr(str.length - 4)}`
}

export function getLocationQuery(location) {
  return queryString.parse(location.search)
}

export function getUrlSearch(parsed) {
  return queryString.stringify(parsed)
}

export function getError(error) {
  if (error.graphQLErrors && error.graphQLErrors[0] && error.graphQLErrors[0].message &&
      error.graphQLErrors[0].message.detail) {
    return error.graphQLErrors[0].message.detail
  } else if (error.message) {
    if (error.message.indexOf('connect to host') !== -1) {
      return 'Cannot connect to the service'
    }
    if (error.message.indexOf('Network error') !== -1) {
      return 'Network error'
    }
  }
  return 'Undefined error'
}



// WEBPACK FOOTER //
// ./src/utils.js